<template>
  <div class="device">
    <div class="layout" style="margin-top:5.9375rem;">
      <div class="device-setting">
        <div class="layout-header" ref="searchBox" style="background:transparent;padding:1rem;width: calc(100% - 0.875rem);">
          <div style="padding: 1rem; background: #FFF;">
            <div class="infor-layout-header mb20">
              <span class="title">站点同步</span>
            </div>
            <div>
              <el-row type="flex" class="row-bg" justify="space-between">
                <el-col :span="18">
                  <el-form :inline="true" :model="formInline" class="demo-form-inline">
                    <el-form-item label="品牌名称：">
                      <el-select v-model="copy.brandId" placeholder="请选择品牌" clearable>
                        <el-option
                          :label="item.value"
                          :value="item.key"
                          v-for="item in brands"
                          :key="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="创建日期：">
                      <el-date-picker
                        v-model="copy.dataRange"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd HH:mm:ss"
                      >
                      </el-date-picker>
                    </el-form-item>
                    <el-form-item label="接口类型">
                      <el-select v-model="copy.apiType" style="width: 150px">
                        <el-option
                          :label="item.label"
                          :value="item.key"
                          v-for="item in apiTypeOptions"
                          :key="item.key"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-button @click="check">查询</el-button>
                      <el-button type="primary" @click="refresh" style="background-color: #3e7878;border-color: #3e7878">重置</el-button>
                    </el-form-item>
                  </el-form>
                </el-col>
                <el-col :span="6">
                  <div class="mt5 textRight">
                    <el-button v-if="userLevel >= 2 && isAggregation" type="primary" v-show="checkUserAuth(3, 117)" :size="size" @click="newSiteWl(null, false)">添加禁停区</el-button>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
        <div style="height:9.875rem;"></div>
        <div class="m16 pagination-bg-white device table-container" style="padding-bottom: 15px;height: 73%;">
          <w-table
            width="100%"
            v-show="checkUserAuth(4, 14)"
            v-loading.body="tableLoading"
            :height="tableViewHeight"
            :data-list="tabledata"
            :columns="columns"
            :pageNo="formData.pageNum"
            :pageSize="formData.pageSize"
            :total="total"
            @pageNoChange="pageNoChange"
            @pageSizeChange="handleSizeChange">
            <template v-slot:cell="props">
              <span v-if="props.column.label === '接口类型'">
                 {{ props.row["api_type"] | filterApiType }}
              </span>
              <span v-else-if="props.column.label === '品牌名称'">
                {{ props.row['brand_id'] | filterBrandName(brands) }}
              </span>
              <span v-else>{{ props.row[props.column.property]}}</span>
            </template>
          </w-table>
          <div v-show="!checkUserAuth(4, 14)">您的账户没有权限查看此内容！</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import WTable from '@/components/Table/index.vue'
import Api from '@/api'
import {
  mapGetters
} from 'vuex'
export default {
  name: 'sitesync',
  components: {
    WTable
  },
  data() {
    return {
      copy: {
        apiType: 'all'
      },
      form: {},
      tableViewHeight: '',
      columns: [
        {
          prop: 'brand_id',
          label: '品牌名称'
        },
        {
          prop: 'api_type',
          label: '接口类型'
        },
        {
          prop: 'create_time',
          label: '调用日期'
        }
      ],
      tableLoading: true,
      tabledata: [],
      formData: {
        pageNum: 1,
        pageSize: 20
      },
      total: 0,
      apiTypeOptions: [
        {
          key: 'all',
          label: '全部'
        }, {
          key: 1,
          label: '站点同步接口'
        }, {
          key: 2,
          label: '禁停区接口'
        }, {
          key: 3,
          label: '禁行区接口'
        }]
    }
  },
  filters: {
    filterApiType(value) {
      return {
        1: '站点同步接口',
        2: '禁停区接口',
        3: '禁行区接口'
      }[Number(value)]
    },
    filterBrandName(value, brands) {
      return brands.some(item => String(item.brandId) === String(value))
        ? brands.find(item => String(item.brandId) === String(value)).brandName
        : undefined
    }
  },
  computed: {
    ...mapGetters(['user', 'selfAreaId', 'userLevel', 'brands'])
  },
  created() {
    this.refresh()
  },
  methods: {
    handleSizeChange(newSize) {
      this.formData.pageSize = newSize
      this.refresh()
    },
    check() {
      this.form = { ...this.copy }
      this.getData()
    },
    refresh() {
      this.form = {
        dataRange: [this.dayjs().startOf('M').format('YYYY-MM-DD HH:mm:ss'),
          this.dayjs().endOf('M').format('YYYY-MM-DD HH:mm:ss')],
        apiType: 'all'
      }
      this.copy = { ...this.form }
      this.formData.pageNum = 1
      this.getData()
    },
    getData() {
      this.tableLoading = true
      const postdata = {
        selfAreaId: this.selfAreaId,
        currentPage: this.formData.pageNum,
        pageSize: this.formData.pageSize
      }
      if (this.form.brandId) {
        postdata.brandId = this.form.brandId
      }
      if (this.form.apiType !== 'all') {
        postdata.apiType = this.form.apiType
      }
      if (this.form.dataRange) {
        postdata.startTime = this.form.dataRange[0]
        postdata.endTime = this.form.dataRange[1]
      }
      Api.getSyncSiteLogList(postdata).then((res) => {
        this.tableLoading = false
        if (res.code === 200 && res.data) {
          this.tabledata = res.data.lists
          this.total = res.data.total
        } else {
          this.$message.warning(res.message)
        }
        this.calcView()
      })
    },
    calcView() {
      this.$nextTick(() => {
        let H = 0
        if (this.$refs.searchBox && this.$refs.searchBox.clientHeight) {
          H += Number(this.$refs.searchBox.clientHeight)
        }
        console.log('H', H)
        // 56: 导航栏高度修正
        // 79: table分页器高度修正
        this.tableViewHeight = window.innerHeight - 56 - H - 96 - 56
      })
    },
    pageNoChange(page) {
      this.formData.pageNum = page
      this.getData()
    }
  }
}
</script>

<style lang="less">
@import "../../../styles/index.less";
.device-setting {
  background: rgba(240, 242, 245, 1);
  width: 100%;
  height: 100%;
  overflow-y: scroll;
}
.device {
  #echarts {
    width: 780px;
    height: 400px;
  }
}
.device .el-table .cell {
  padding-right: 0;
  padding-left: 0;
}
.table-container{
  background-color: white;
}
</style>
